import axios from "axios";
import {API_BASE_URL_V2} from "../../services/config";
import {IUnAvailabilityFormValues} from "./i-unavailability-form";

const baseUrl = API_BASE_URL_V2;
const endpoint = "booking/unavailability";

// create user unavailability
export const createUnavailabilityService = async (
  selections: IUnAvailabilityFormValues,
  token: string
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(baseUrl + endpoint, selections, config);

  return response.data;
};
// Get user unavailability
export const getUserUnavailabilityService = async (token: string) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get(baseUrl + endpoint, config);

  return response.data;
};
